import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import LogoService from '../../../services/logo.service';
import CreateLogoModal from "../../modals/CreateLogoModal";
import Button from "react-bootstrap/Button";
import { Diagram2, Pencil } from 'react-bootstrap-icons';
const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

const LogoList = () => {
  const navigate = useNavigate();
  const [ logos, setLogos ] = useState(null);
  const [ availableLogos, setAvailableLogos ] = useState(null);
  const [ modalShow, setModalShow ] = useState(false);
  const [ reload, setReload ] = useState(false);
  const [ currentLogo, setCurrentLogo ] = useState({});

  useEffect(() => {
    async function fetchMyAPI() {
      let logos = await LogoService.getLogos();
      let availableLogos = await LogoService.getAvailableLogos();

      console.log("LOGOS", logos);
      console.log("AVAILABLe LOGOS", availableLogos);
      var newLogos = [];
      var found = false;
      for(var i = 0; i < logos.data.length; i++) {
        for(var j=0; j < availableLogos.data.length; j++) {
          if(availableLogos.data[j].id === logos.data[i].id) {
            found = true;
          }
        }
        if(!found) newLogos.push(logos.data[i]);
        found = false;
      }

      setLogos(newLogos);
      setAvailableLogos(availableLogos.data);

    }

    fetchMyAPI();
  }, []);

  const closeModal = async (status) => {
    setModalShow(false);
    if(status) setReload(!reload);
    let logos = await LogoService.getLogos();
      console.log(logos);
      setLogos(logos.data);
  }

  const showModal = () => {
    setModalShow(true);
  }
  const addLogo = async (logo) => {
    await LogoService.addAvailableLogo(logo);

    var newAvailableLogos = [...availableLogos];
    newAvailableLogos.push(logo);

    setAvailableLogos(newAvailableLogos);
    
    var newLogos = [];
    for(var i = 0; i < logos.length; i++) {
      if(logos[i].id !== logo.id) {
        newLogos.push(logos[i]);
      }
    }
    setLogos(newLogos);
  }

  const removeLogo = async (logo) => {
    await LogoService.deleteAvailableLogo(logo.id);
    var newLogos = [...logos];
    newLogos.push(logo);

    var newAvailableLogos = [];
    for(var i = 0; i < availableLogos.length; i++) {
      if(availableLogos[i].id !== logo.id) {
        newAvailableLogos.push(availableLogos[i]);
      }
    }
    setAvailableLogos(newAvailableLogos);
    setLogos(newLogos);
  }



  return (
    <>
      <Button onClick={() => {setCurrentLogo({}); showModal()}}><Diagram2/ > Add Logo</Button>
      <h2>Subsite Logos</h2>
      <div class="product-container">
        {availableLogos && availableLogos.map(logo => (
            <div className="available-logo">
              <div onClick={() => {setCurrentLogo(logo); showModal()}}>
            <img style={{backgroundColor: "#ccc", padding: 10}} src={apiUrl + logo.imageUrl} width="100" />
            <div>Name: {logo.decorationName}</div>
            <div>Type: {logo.decoType}</div>
            </div>
            <div style={{display: "flex", flexGrow: 1, flexDirection: "column-reverse"}} ><Button onClick={() => removeLogo(logo)} style={{alignSelf: "flex-end" }}>Remove from Subsite</Button></div>
            </div>
            )
        )}   
      </div>

      <h2>All Logos</h2>
      <div class="product-container">
        {logos && logos.map(logo => (
            <div className="available-logo">
              <div onClick={() => {setCurrentLogo(logo); showModal()}}>
              <img style={{backgroundColor: "#ccc", padding: 10}} src={apiUrl + logo.imageUrl} width="100" />
            <div>Name: {logo.decorationName}</div>
            <div>Type: {logo.decoType}</div>
            </div>
            <div style={{display: "flex", flexGrow: 1, flexDirection: "column-reverse"}}><Button onClick={() => addLogo(logo)} >Add to Subsite</Button></div>

            </div>
            )
        )}   
      </div>
      {modalShow && <CreateLogoModal show={modalShow} closeModal={closeModal} logo={currentLogo} />}
    </>
  );
};
export default LogoList;

